/**
 * Thrown when a pro-only feature is used without a valid license.
 * Consumer-facing — provides the feature name and upgrade URL for
 * actionable error messages in CLI output and CI logs.
 */
export class PaperJSXFeatureError extends Error {
    feature;
    upgradeUrl = "https://paperjsx.com/pricing";
    constructor(message, feature) {
        super(message);
        this.name = "PaperJSXFeatureError";
        this.feature = feature ?? "unknown";
    }
}
